import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetDashboardTotalViewsInterface {
  startDate: string;
  endDate: string;
}

export const useGetDashboardTotalViews = () => {
  const mutate = useMutation(({ startDate, endDate }: GetDashboardTotalViewsInterface) => {
    return get(`/enterprise-tickets-api/get_tickets_with_date_range/${startDate}/${endDate}`);
  });

  return mutate;
};

export default useGetDashboardTotalViews;
